export default "__VITE_ASSET__D2GRdS4M__"